/**
 * This is a copy of the 'views/fields/mainContentEmpty.js' file.
 * It is also the file that handles dropping new field types on our repeater field.
 * 
 */

define( 'views/fields/preview/repeaterElementEmpty',[], function() {
	var view = Marionette.ItemView.extend({
		tagName: 'div',
		template: '#tmpl-nf-repeater-content-fields-empty',

		initialize: function( data ) {
			this.repeaterFieldModel = data.repeaterFieldModel;
		},

		onBeforeDestroy: function() {
			jQuery( this.el ).parent().removeClass( 'nf-fields-empty-droppable' ).droppable( 'destroy' );
		},

		onRender: function() {
			this.$el = this.$el.children();
			this.$el.unwrap();
			this.setElement( this.$el );
		},

		onShow: function() {
			if ( jQuery( this.el ).parent().hasClass( 'ui-sortable' ) ) {
				jQuery( this.el ).parent().sortable( 'destroy' );
			}
			jQuery( this.el ).parent().addClass( 'nf-fields-empty-droppable' );
			let that = this;
			jQuery( this.el ).parent().droppable( {
				accept: function( draggable ) {
					if ( jQuery( draggable ).hasClass( 'nf-stage' ) || jQuery( draggable ).hasClass( 'nf-field-type-button' ) ) {
						return true;
					}
				},
				activeClass: 'nf-droppable-active',
				hoverClass: 'nf-droppable-hover',
				tolerance: 'pointer',

				over: function( e, ui ) {	
					
					ui.item = ui.draggable;
					jQuery(ui.item).addClass("nf-over-repeater");
					nfRadio.channel( 'app' ).request( 'over:fieldsSortable', ui );
				},
				out: function( e, ui ) {
				
					ui.item = ui.draggable;
					jQuery(ui.item).removeClass("nf-over-repeater");
					nfRadio.channel( 'app' ).request( 'out:fieldsSortable', ui );
				},
				/**
				 * Handles the dropping of items into our EMPTY repeater field.
				 * 
				 */
				drop: function( e, ui ) {
					ui.item = null != ui.item ? ui.item : ui.draggable;
					nfRadio.channel( 'fields-repeater' ).request( 'add:childField', ui, that, e );
				},
			} );
		}
	});

	return view;
} );
